import React from 'react';
import { Box, Typography, FormControlLabel, Checkbox, Button } from '@mui/material';
import styled from 'styled-components';
import { StyledTextField } from '../FormComponents';
import PasswordStrengthIndicator from './PasswordStrengthIndicator';
import { colors } from '../../modules/constants/colors';

const FormSection = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const SectionTitle = styled(Typography)`
  color: #333;
  font-weight: 600;
  margin-bottom: 24px;
  font-family: "Montserrat", sans-serif;
  text-align: center;
`;

const SecurityStep = ({ 
  formData, 
  errors, 
  onChange, 
  passwordStrength, 
  onShowTerms 
}) => {
  return (
    <FormSection>
      <SectionTitle variant="h6">Account Security</SectionTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          width: "100%",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <StyledTextField
            type="password"
            label="Password"
            name="password"
            value={formData.password}
            onChange={onChange}
            required
            error={!!errors.password}
            helperText={errors.password}
            sx={{ width: "100%" }}
          />
          {formData.password && (
            <PasswordStrengthIndicator
              password={formData.password}
              strength={passwordStrength}
            />
          )}
        </Box>
        <StyledTextField
          type="password"
          label="Confirm Password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={onChange}
          required
          error={!!errors.confirmPassword}
          helperText={errors.confirmPassword}
          sx={{ width: "100%" }}
        />
        <Box sx={{ width: "100%" }}>
          <FormControlLabel
            control={
              <Checkbox
                name="acceptTerms"
                checked={formData.acceptTerms}
                onChange={onChange}
                sx={{
                  color: colors.primary,
                  "&.Mui-checked": {
                    color: colors.primary,
                  },
                }}
              />
            }
            label={
              <Typography
                variant="body2"
                sx={{ fontFamily: "Montserrat" }}
              >
                I agree to the{" "}
                <Button
                  variant="text"
                  size="small"
                  onClick={onShowTerms}
                  sx={{
                    color: colors.primary,
                    textDecoration: "underline",
                    p: 0,
                    minWidth: "auto",
                    fontFamily: "Montserrat",
                    fontSize: "0.875rem",
                    textTransform: "none",
                  }}
                >
                  Terms of Service and Privacy Policy
                </Button>
              </Typography>
            }
          />
          {errors.acceptTerms && (
            <Typography
              variant="caption"
              color="error"
              sx={{ display: "block", mt: 1, ml: 4 }}
            >
              {errors.acceptTerms}
            </Typography>
          )}
        </Box>
      </Box>
    </FormSection>
  );
};

export default SecurityStep;
